export function initAntiInspect() {
  if (typeof window === 'undefined') return () => {}

  const handleContextMenu = (e: MouseEvent) => {
    e.preventDefault()
  }

  const handleKeyDown = (e: KeyboardEvent) => {
    // F12
    if (e.key === 'F12') {
      e.preventDefault()
    }
    // Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C
    if (
      e.ctrlKey &&
      e.shiftKey &&
      (e.key === 'I' || e.key === 'J' || e.key === 'C')
    ) {
      e.preventDefault()
    }
    // Ctrl+U (View Source)
    if (e.ctrlKey && e.key === 'u') {
      e.preventDefault()
    }
  }

  try {
    document.addEventListener('contextmenu', handleContextMenu)
    document.addEventListener('keydown', handleKeyDown)
    console.log(
      '%c🔒 Security protocols active. Source inspection is disabled.',
      'color: #C9A961; font-weight: bold; font-size: 14px;',
    )
  } catch (error) {
    console.error('Security init failed', error)
  }

  return () => {
    try {
      document.removeEventListener('contextmenu', handleContextMenu)
      document.removeEventListener('keydown', handleKeyDown)
    } catch (error) {
      // ignore
    }
  }
}
